var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73813 9.4405H5.92863M13.0478 13.8215H2.09525C1.49067 13.8215 1 13.3308 1 12.7263V1.77375C1 1.16917 1.49067 0.678497 2.09525 0.678497H13.0478C13.6523 0.678497 14.143 1.16917 14.143 1.77375V12.7263C14.143 13.3308 13.6523 13.8215 13.0478 13.8215ZM3.73813 5.0595H5.92863H3.73813Z",
    stroke: "#627790",
    strokeWidth: 1.09525,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57153 3.96426H10.8573V6.15476H7.57153V3.96426ZM7.57153 8.34526H10.8573V10.5358H7.57153V8.34526Z",
    stroke: "#627790",
    strokeWidth: 1.09525,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsIcon);
export default __webpack_public_path__ + "static/media/forms-icon.737f28329a65e5d7ea4a5ec4697e944d.svg";
export { ForwardRef as ReactComponent };